import TriggerConfig from 'eflex/models/trigger-config';
import { belongsTo, hasMany, attr } from '@ember-data/model';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { isBelongsToRefDirty, rollbackBelongsTo } from 'eflex/util/relationship-helpers';

export default class WorkInstructionHardwareTriggerConfig extends TriggerConfig {
  @service workInstructionRepo;

  @attr('string') externalImageUrl;
  @attr('number') page;

  @belongsTo('work-instruction', { async: false, inverse: 'workInstructionHardwareTriggerConfigs' }) workInstruction;

  @hasMany('work-instruction-animation', {
    async: false,
    inverse: 'workInstructionHardwareTriggerConfig',
    embedded: true,
  }) animations;

  get nonDeletedAnimationCount() {
    const animations = this.animations.filter(animation => !animation.isDeleted);
    return animations.length;
  }

  get isDirty() {
    return super.isDirty ||
      isBelongsToRefDirty(this, 'workInstruction') ||
      this.animations.some(item => item.isDirty);
  }

  get hasExternalUrl() {
    return isPresent(this.externalImageUrl);
  }

  get fullExternalUrl() {
    if (this.externalImageUrl == null) {
      return null;
    } else if (this.page == null) {
      return this.externalImageUrl;
    } else {
      return `${this.externalImageUrl}#page=${this.page}`;
    }
  }

  copyAnimations(animations) {
    for (const animation of animations) {
      const copy = animation.copy();
      this.animations.push(copy);
    }
  }

  setExternalImageUrl(url, page) {
    this.workInstructionRepo.setExternalImageUrl(this, url, page);
  }

  setWorkInstruction(workInstruction) {
    this.workInstructionRepo.setWorkInstruction(this, workInstruction);
  }

  rollbackAttributes() {
    rollbackBelongsTo(this, 'workInstruction');
    super.rollbackAttributes();
  }
}
